import Quill from 'quill';
import variables from '../../../variables';

const Embed = Quill.import('blots/embed');

export default function () {
  const self = this;

  class TemplateMarker extends Embed {
    static create(value) {
      const node = super.create(value);
      node.setAttribute('class', 'badge badge-' + value.colour);
      node.setAttribute('data-marker', value.marker);
      node.setAttribute('data-colour', value.colour);
      node.innerHTML = variables().find(v => v.value === value.marker).label;
      return node;
    }

    static value(node) {
      return {
        marker: node.getAttribute('data-marker'),
        colour: node.getAttribute('data-colour'),
      };
    }
  }

  TemplateMarker.blotName = 'TemplateMarker';
  TemplateMarker.tagName = 'span';

  return TemplateMarker;
}
